exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#OrderStatusSelfService[data-v-46e44b64]{height:40em;padding-bottom:100vh}.image[data-v-46e44b64]{height:500;width:500;padding-bottom:5vh}#OrderStatusSelfService div[data-v-46e44b64]{margin:0;position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%,-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46e44b64","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/OrderStatusSelfService.vue
// module id = 532
// module chunks = 0